import Vue from 'vue'
import Vuex from 'vuex'
import lockr from 'lockr'
import firebase from '@/service/firebase'
import init from '@/store/init'
import filter from '@/store/filters'

// Setup available categories
let hideAllCategoriesConfig = {}
let showAllCategoriesConfig = {}
require('@/mixins/categories').forEach((category) => {
  hideAllCategoriesConfig[category.value] = true
  showAllCategoriesConfig[category.value] = false
})

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    isMainSidebarActive: false,
    isLoginModalActive: false,
    isProfileModalActive: false,
    isResourceModalActive: false,
    isAboutModalActive: false,
    isLoadingResources: true,
    isIntakeModalActive: false,
    isIntakeConfigModalActive: false,

    user: {},
    resources: lockr.get('resources') || {},
    visibleResources: {},
    hiddenResources: {},
    checklist: lockr.get('checklist'),

    // Stores the intake form's temporary config data as populated by @/components/checklist/Intake
    intakeConfig: Object.assign({}, init.intakeConfig),

    // Stores the users intake data
    intakeData: Object.assign({}, lockr.get('intakeData') || init.intakeConfig),

    // {Null|Object} The mode to open the resource modal in. {NULL} for add or {OBJECT = resource} for edit
    editingResource: null,
    activeCategories: showAllCategoriesConfig,
    hasActiveMarkers: false,

    view: 'main'
  },

  mutations: {
    // Modals and Sidebars
    toggleMainSidebar: state => (state.isMainSidebarActive = !state.isMainSidebarActive),
    toggleLoginModal: state => (state.isLoginModalActive = !state.isLoginModalActive),
    toggleProfileModal: state => (state.isProfileModalActive = !state.isProfileModalActive),
    toggleResourceModal (state, resource) {
      state.editingResource = resource
      state.isResourceModalActive = !state.isResourceModalActive
    },
    toggleAboutModal: state => (state.isAboutModalActive = !state.isAboutModalActive),
    toggleIntakeModal: state => (state.isIntakeModalActive = !state.isIntakeModalActive),
    toggleIntakeConfigModal: state => (state.isIntakeConfigModalActive = !state.isIntakeConfigModalActive),
    closeModals (state) {
      state.isMainSidebarActive = false
      state.isLoginModalActive = false
      state.isProfileModalActive = false
      state.isAboutModalActive = false
      state.isIntakeModalActive = false
    },

    // User
    setUser: (state, user) => (state.user = user),
    // @TODO Toast success
    // @TODO Catche error
    deleteUser (state) {
      state.user.delete()
      state.user = {}
    },
    logout (state) {
      state.user = {}
      state.checklist = null
      firebase.auth().signOut()
    },

    // Categories
    toggleCategories (state, categories) {
      categories.forEach((category) => {
        let isActive = !!state.activeCategories[category]
        Vue.set(state.activeCategories, category, !isActive)
      })
    },
    showAllCategories (state) {
      state.activeCategories = showAllCategoriesConfig
    },
    hideAllCategories (state) {
      state.activeCategories = hideAllCategoriesConfig
    },

    // Resources
    setResources (state, data) {
      state.resources = data
    },
    toggleLoadingResources: (state, isLoading) => (state.isLoadingResources = isLoading),
    filterResources (state) {
      if (!state.resources) return
      let filtered = {}

      if (state.view === 'checklist' && state.checklist) {
        filtered = filter.byChecklist(state.resources, state.checklist)
      } else {
        filtered = filter.byCategory(state.resources, state.activeCategories)
      }

      state.visibleResources = filtered.visible
      state.hiddenResources = filtered.hidden
      state.hasActiveMarkers = filtered.hasActiveMarkers

      lockr.set('resources', filtered.visible)
    },

    // Checklist
    setChecklist (state, data) {
      state.checklist = data
      lockr.set('checklist', data)
    },
    viewChecklist: (state) => (state.view = 'checklist'),
    viewMain: (state) => (state.view = 'main'),

    // Intake
    clearIntakeConfig: (state) => (state.intakeConfig = Object.assign({}, init.intakeConfig)),
    setIntakeConfig: (state, data) => (state.intakeConfig = data || Object.assign({}, init.intakeConfig))
  }
})

export default store
require('@/store/user')
require('@/store/resource')
require('@/store/checklist')



// WEBPACK FOOTER //
// ./src/store.js